import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  FaTachometerAlt, 
  FaUsers, 
  FaCalendarCheck, 
  FaQuestionCircle, 
  FaUserShield,
  FaUser,
  FaSignOutAlt
} from 'react-icons/fa';
import { useAuth } from '../../hooks/useAuth';
import { toast } from 'react-toastify';

const Sidebar = ({ onNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const menuItems = [
    {
      key: 'dashboard',
      title: 'Dashboard',
      icon: FaTachometerAlt,
      path: '/dashboard',
      roles: ['user', 'visa_office', 'admin']
    },
    {
      key: 'users',
      title: 'Kullanıcılar',
      icon: FaUsers,
      path: '/users',
      roles: ['user', 'visa_office', 'admin']
    },
    {
      key: 'appointments',
      title: 'Aranılan Tarihler',
      icon: FaCalendarCheck,
      path: '/appointments',
      roles: ['user', 'visa_office', 'admin']
    },
    {
      key: 'faq',
      title: 'SSS',
      icon: FaQuestionCircle,
      path: '/faq',
      roles: ['user', 'visa_office', 'admin']
    },
    {
      key: 'profile',
      title: 'Profil',
      icon: FaUser,
      path: '/profile',
      roles: ['user', 'visa_office', 'admin']
    },
    {
      key: 'admin',
      title: 'Yönetim',
      icon: FaUserShield,
      path: '/admin',
      roles: ['admin']
    }
  ];

  const hasAccess = (roles) => {
    return roles.includes(user?.role);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleNavigation = (path) => {
    navigate(path);
    // Close sidebar on mobile after navigation
    if (onNavigate && window.innerWidth < 768) {
      onNavigate();
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Çıkış başarılı!');
      navigate('/login');
    } catch (error) {
      toast.error('Çıkış yapılırken bir hata oluştu.');
    }
  };

  return (
    <div className="p-3 d-flex flex-column h-100">
      {/* Logo */}
      <div className="mb-4 text-center">
        <h4 className="text-primary fw-bold mb-0">quickestvisa Panel</h4>
      </div>

      {/* Navigation */}
      <Nav className="flex-column">
        {menuItems.map((item) => {
          if (!hasAccess(item.roles)) {
            return null;
          }

          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Nav.Item key={item.key} className="mb-1">
              <Nav.Link
                className={`d-flex align-items-center py-3 px-3 rounded text-decoration-none ${
                  active 
                    ? 'bg-primary text-white' 
                    : 'text-dark hover-bg-light'
                }`}
                onClick={() => handleNavigation(item.path)}
                style={{ cursor: 'pointer' }}
              >
                <Icon 
                  size={18} 
                  className={`me-3 ${active ? 'text-white' : 'text-primary'}`} 
                />
                <span className="fw-medium">{item.title}</span>
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>

      {/* User Info */}
      <div className="mt-auto pt-4">
        <div className="border-top pt-3">
          <div className="d-flex align-items-center text-muted mb-3">
            <FaUser size={16} className="me-2" />
            <div>
              <div className="fw-medium text-dark" style={{ fontSize: '0.875rem' }}>
                {user?.first_name} {user?.last_name}
              </div>
              <small className="text-muted">
                {user?.role === 'admin' ? 'Yönetici' : 
                 user?.role === 'visa_office' ? 'Danışmanlık Firması' : 'Kullanıcı'}
              </small>
            </div>
          </div>
          
          {/* Logout Button - Only visible on mobile */}
          <Button
            variant="outline-danger"
            size="sm"
            className="w-100 d-md-none"
            onClick={handleLogout}
          >
            <FaSignOutAlt size={14} className="me-2" />
            Çıkış Yap
          </Button>
          
          {/* Version */}
          <div className="text-center mt-3">
            <small className="text-muted" style={{ fontSize: '0.75rem' }}>v1.0.0</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 